import {
  isEqual
} from 'helpers';

export class Config {

  constructor(fields) {

    this.fields = fields;
  }

  mapToStandard() {

    return {
      enableTopBanner: this.fields?.attributes?.field_enable_top_banner,
      topBannerContent: this.fields?.attributes?.field_top_banner_content.processed,
      enableWhatsNewBanner: this.fields?.attributes?.field_enable_whats_new_banner,
      whatsNewBannerContent: this.fields?.attributes?.field_whats_new_banner_content.processed,
      whatsNewBannerTitle: this.fields?.attributes?.field_whats_new_banner_title.processed,
      j4uErrorMessage: this.fields?.attributes?.field_j4u_error_message.processed,
      feature_toggles: this.fields?.attributes?.field_feature_toggles,
      enableHomeNotification: this.fields?.attributes?.field_enable_home_notification,
      homeNotification: this.fields?.attributes?.field_home_notification,
      fairUsagePolicy: this.fields?.attributes?.field_fair_usage_policy,
      voucherAdvanceConfig: this.fields.attributes?.relationships
        .filter(rel => isEqual(rel.field, 'field_voucher_advance_config'))
        .map(config => {
          return {
            eligibleDescription: config.eligibleDescription?.processed,
            ineligibleDescription: config.ineligibleDescription?.processed,
            paymentSuccessMessage: config.paymentSuccessMessage?.processed,
            voucherShareMessage: config.voucherShareMessage,
            confirmOrderTitle: config.confirmOrderTitle,
            confirmOrderDescription: config.confirmOrderDescription?.processed,
            advanceSuccessMessage: config.advanceSuccessMessage?.processed,
            buyNowBanner: config.buyNowBanner?.processed,
            voucherRedeemText: config.voucherRedeemText?.processed,
            vouchersUnavailableError: config.vouchersUnavailableError?.processed,
            outletsUnavailableError: config.outletsUnavailableError?.processed,
            purchaseHistoryError: config.purchaseHistoryError,
            noPastPurchases: config.noPastPurchases
          };
        })[0],
      advancePromptConfig: this.fields.attributes?.relationships
        .filter(rel => isEqual(rel.field, 'field_advance_prompt_config'))
        .map(config => {
          return {
            minimumAirtimeBalance: config.minimumAirtimeBalance,
            minimumDataBalance: config.minimumDataBalance,
            promptHeaderText: config.promptHeaderText,
            promptBodyText: config.promptBodyText
          };
        })[0],
      miniApps: this.fields.attributes?.relationships
        .filter(rel => isEqual(rel.field, 'field_mini_apps'))
        .map(config => {
          return {
            miniAppId: config.miniAppId,
            miniAppName: config.miniAppName
          };
        })
    };
  }
}